import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import SeminarSchedulerA from 'components/SeminarScheduler/SeminarSchedulerA';
import addSeminarStartAndEndDateBySession from 'utils/Product';

class SeminarSchedulerContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showProducts: props.expanded,
      selectedProductModal: 0,
    };

    this.onClick = this.onClick.bind(this);
    this.openProductModal = this.openProductModal.bind(this);
    this.closeProductModal = this.closeProductModal.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    const { showProducts } = this.state;
    this.setState({ showProducts: !showProducts });
  }

  openProductModal(productId) {
    this.setState({ selectedProductModal: productId });
  }

  closeProductModal() {
    this.setState({ selectedProductModal: 0 });
  }

  render() {
    const { items = [], heading } = this.props;
    const { showProducts, selectedProductModal } = this.state;
    const orderedItems = orderBy(items.map((i) => addSeminarStartAndEndDateBySession(i)),
      ['seminarInfo.start', 'displayName'], ['asc', 'asc']);

    return (
      items.length > 0 &&
      <SeminarSchedulerA
        items={orderedItems}
        showProducts={showProducts}
        selectedProductModal={selectedProductModal}
        title={heading}
        onClick={this.onClick}
        openProductModal={this.openProductModal}
        closeProductModal={this.closeProductModal}
      />);
  }
}

SeminarSchedulerContainer.propTypes = {
  /**
   * A list of seminar scheduler items
  */
  items: PropTypes.array.isRequired,
  /**
   * Text for expand/collapse heading
  */
  heading: PropTypes.string,
  /**
   * Heading defaults to expanded
  */
  expanded: PropTypes.bool,
};

export default SeminarSchedulerContainer;
